import { createStyles, makeStyles } from '@material-ui/core/styles';
import { YELLOW } from 'constants/colors';
export default makeStyles(() => createStyles({
  warningIcon: {
    color: YELLOW,
    position: 'relative',
    top: '3px',
    marginLeft: '10px'
  }
}));